
import { mapState } from "vuex";
import KotMarketingQrCode from "../common/kot-marketing-qr-code.vue";
export default {
  components: { KotMarketingQrCode },
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loadedImages: 0,
      imageCount: 0,
      unLoadedImages: 0
    };
  },
  mounted() {
    this.imageCount =
      this.$refs["bill-template"].querySelectorAll("img.custom-image").length;
    this.checkAndEmitDocumentReady();
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("restaurant", ["locationDetails", "businessDetails"]),
    comboFilteredItems() {
      return this.getItemListWithItemsAndCombos(this.items) || [];
    },
    totalItems() {
      return this.comboFilteredItems.reduce(
        (acc, item) =>
          acc + item.combo_quantity ? item.combo_quantity : item.quantity,
        0
      );
    },

    isSmallPrinter() {
      return this.$ls.get("printer-type", "md") == "sm";
    },
    printLogoInBill() {
      return this.getBoolean(this.$ls.get("print-logo-in-bill", false));
    }
  },
  methods: {
    getRounding(order) {
      if (order && order.round_off) {
        return Math.abs(order.round_off) / 100;
      } else {
        return 0;
      }
    },
    isFoodSafetyEnabled() {
      return this.getBoolean(this.$ls.get("health-message", true));
    },
    handleImageLoaded() {
      this.loadedImages++;
      this.checkAndEmitDocumentReady();
    },
    handleImageError() {
      this.unLoadedImages++;
      this.checkAndEmitDocumentReady();
    },
    checkAndEmitDocumentReady() {
      const totalImages = this.loadedImages + this.unLoadedImages;

      if (totalImages === this.imageCount) {
        this.$emit("document-ready");
      }
    },
    getPricingInfo(item) {
      let qty = parseFloat(
        item.combo_quantity ? item.combo_quantity : item.quantity
      );
      let itemOptionsToAdd = this.itemOptions(item);
      let amt = 0;
      let unitPrice = 0;
      const isCombo = !!item.items?.length;
      if (itemOptionsToAdd.length > 0) {
        unitPrice = item.options_to_add.reduce((a, c) => a + c.price, 0);
        amt = qty * parseFloat(unitPrice);
      } else {
        unitPrice = isCombo ? item.amount : item.unit_price;
        amt = qty * parseFloat(unitPrice);
      }

      amt = amt.toFixed(2);
      if (item.price_unit === "kilograms") {
        unitPrice = unitPrice + "/kg";
      }
      return { amt, unitPrice };
    },
    getItemAmount(item) {
      let pricingInfo = this.getPricingInfo(item);
      return pricingInfo.amt;
    },
    getItemUnitPrice(item) {
      let pricingInfo = this.getPricingInfo(item);
      return pricingInfo.unitPrice;
    }
  }
};
